// feature name
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ActionsEnum,
  FetchInstantWebsiteSettingsError,
  FetchInstantWebsiteSettingsSuccess,
  SaveInstantWebsiteSettingsNetworkError,
  SaveInstantWebsiteSettingsNetworkSuccess,
} from './instant-website.actions';
import { combineActions, handleActions } from 'redux-actions';
import { IInstantWebsiteSettings } from './instant-website-data.data';

export const FEATURE_NAME = 'instant-website-data';

export interface IState {
  settings: IInstantWebsiteSettings;
  error: Error;
}

// initial state
export const initialState: IState = {
  settings: null,
  error: null,
};

//reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.FETCH_INSTANT_WEBSITE_SETTINGS]: function (
      state: IState
    ): IState {
      return {
        ...state,
        settings: null,
        error: null,
      };
    },
    [ActionsEnum.FETCH_INSTANT_WEBSITE_SETTINGS_SUCCESS]: function (
      state: IState,
      { payload }: FetchInstantWebsiteSettingsSuccess
    ): IState {
      return {
        ...state,
        settings: payload.settings,
        error: null,
      };
    },
    [ActionsEnum.SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK_SUCCESS]: function (
      state: IState,
      { payload }: SaveInstantWebsiteSettingsNetworkSuccess
    ): IState {
      return {
        ...state,
        settings: payload.settings,
        error: null,
      };
    },
    [combineActions(
      ActionsEnum.FETCH_INSTANT_WEBSITE_SETTINGS_ERROR,
      ActionsEnum.SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK_ERROR
    )]: function (
      state: IState,
      {
        payload,
      }:
        | FetchInstantWebsiteSettingsError
        | SaveInstantWebsiteSettingsNetworkError
    ): IState {
      return {
        ...state,
        error: payload.error,
      };
    },
  } as any,
  initialState
);

export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getInstantWebsiteSettings = createSelector(
  selectFeature,
  (state: IState) => state.settings
);
